import { render } from "./Acceso.vue?vue&type=template&id=53a34fd9&scoped=true"
import script from "./Acceso.vue?vue&type=script&lang=js"
export * from "./Acceso.vue?vue&type=script&lang=js"

import "./Acceso.vue?vue&type=style&index=0&id=53a34fd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a34fd9"]])

export default __exports__